import { AspectRatio, Box, Flex, Text } from '@chakra-ui/react';
import { ITaxonomyTerms } from '@kontent-ai/delivery-sdk';
import { Link } from 'components/base/Link';
import { Tag } from 'components/base/Tag';
import { htmlResolver } from 'helpers/htmlResolver';
import { LinkType } from 'lib/enums/LinkType';
import { ContentPage } from 'models';
import Image from 'next/image';
import { normalize } from 'pages/api/sitemap';
import { withTranslations } from 'store/translations';

import { getLocalizedDate } from './getLocalizedDate';
import { imageFormatter } from './imageFormatter';
export interface OptionsProps extends Partial<ITaxonomyTerms> {
  amountOfPagesWithTag?: number;
  amountOfOffersWithTag?: number;
  apiCodename?: string;
}
import { useCookies } from 'react-cookie';

export const ItemBlock = ({ page }: { page: ContentPage }) => {
  const translations = withTranslations();
  const imageData = imageFormatter(page.elements.summaryImageFrontify.value);
  const title = page.elements.summaryTitle.value;
  const description = htmlResolver(page.elements.summaryDescription);
  const typeArraySector = page.elements[
    page.elements?.category.value[0]?.codename === 'insight' ? 'tagsThemeTopic' : 'tagsSector'
  ].value?.map((obj) => translations.sector(obj.codename));
  const typeArrayInsight = page.elements[
    page.elements?.category.value[0]?.codename === 'insight' ? 'tagsThemeTopic' : 'tagsSector'
  ].value?.map((obj) => translations.theme_topic(obj.codename));
  // const concatenatedNames = page.elements[
  //   page.elements?.category.value[0]?.codename === 'insight' ? 'tagsThemeTopic' : 'tagsSector'
  // ].value?.reduce((result, tag) => {
  //   return result + (result ? ', ' : '') +  translations.sector(tag.codename);
  // }, '');
  const type =
    page.elements?.category.value[0]?.codename === 'insight' ? typeArrayInsight.join(', ') : typeArraySector.join(', ');
  // ?.codename;
  const featured = page.elements.featured.value[0]?.codename;
  const pageCreation = getLocalizedDate(
    page.elements.summaryDate.value ?? page.system.lastModified,
    translations.locale,
  );
  const contentType = page.elements.tagsContentType.value[0]?.codename;
  const pageType = page.elements.category.value[0]?.codename;
  const url = Object.keys(normalize(page, translations.locale, undefined, true, translations))[0];
  const [_cookie, setCookie] = useCookies();

  const handleBreadcrumbClick = () => {
    switch (pageType) {
      case 'insight':
        setCookie('breadcrumb_name', translations.theme_topic(type));
        break;
      case 'news':
        setCookie('breadcrumb_name', pageCreation);
        break;
      default:
        setCookie('breadcrumb_name', translations.sector(type));
    }
    setCookie('breadcrumb_path', url);
  };

  return (
    <Box
      w={{ base: '100%', lg: pageType === 'news' ? 'calc(33.33% - 26.66px)' : 'calc(50% - 20px)' }}
      // pl={{ base: '0', lg: 's' }}
      // pr={{ base: '0', lg: 's' }}
      pb={{ base: 'mobile.xl', lg: 'desktop.l' }}
      role='group'
      cursor='pointer'
      transition='all 0.2s ease'
      // _hover={{
      //   transform: 'translateY(-4px)',
      // }}
    >
      <Box position={'relative'} overflow='hidden'>
        <Link href={url ?? '/'} locale={translations.locale} type={LinkType.Item} onClick={handleBreadcrumbClick}>
          <AspectRatio
            w='100%'
            ratio={16 / 9}
            overflow='hidden'
            transition='transform 0.2s ease'
            _groupHover={{
              transform: 'scale(1.05)',
            }}
          >
            <Image
              width={imageData.width}
              height={imageData.height}
              src={imageData.src}
              alt={imageData.alt}
              sizes={'(max-width: 1024px) 100vw, 50vw'}
            />
          </AspectRatio>
        </Link>
        <Flex gap='xxs' position='absolute' bottom='m' right='xs'>
          {contentType !== undefined && <Tag type={contentType} aria-label='tag' />}
          {featured === 'yes' && <Tag type='featured' aria-label='tag' />}
        </Flex>
      </Box>
      <Text textStyle={{ base: 'mobile.body.s', lg: 'desktop.body.s' }} pt='0' aria-label='type'>
        {pageType === 'insight' ? (
          <>
            {translations.theme_topic(type)} | {pageCreation}
          </>
        ) : pageType === 'news' ? (
          <>{pageCreation}</>
        ) : (
          type
        )}
      </Text>
      <Link href={url ?? '/'} locale={translations.locale} type={LinkType.Item} onClick={handleBreadcrumbClick}>
        <Text
          textStyle={{ base: 'mobile.h4', lg: 'desktop.h4' }}
          pt='xxs'
          transition='color 0.2s ease'
          _groupHover={{
            color: 'cyan.web',
          }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </Link>
      <>
        {description?.map((desc, index) => {
          return (
            <Text
              key={index}
              textStyle={{ base: 'mobile.body.l', lg: 'desktop.body.l' }}
              dangerouslySetInnerHTML={{ __html: desc.body }}
            />
          );
        })}
      </>
    </Box>
  );
};
// -- Product Block End --
